import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Spinner = () => {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
            <div className="spinner-border text-primary" role="status" aria-label="Loading">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default Spinner;
